var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useMemo } from "react";
import { useTempValue } from "../useTempValue";
import { findMatchIndex as DEFAULT_FIND_MATCH_INDEX } from "./findMatchIndex";
import { DEFAULT_GET_ITEM_VALUE, DEFAULT_SEARCH_RESET_TIME, DEFAULT_VALUE_KEY, } from "./utils";
/**
 * Adds the accessibility functionality to search a list of items as the user
 * types to trigger `aria-activedescendant` focus or manual DOM focus events.
 */
export function useKeyboardSearch(_a) {
    var items = _a.items, onChange = _a.onChange, onKeyDown = _a.onKeyDown, _b = _a.resetTime, resetTime = _b === void 0 ? DEFAULT_SEARCH_RESET_TIME : _b, searchIndex = _a.searchIndex, _c = _a.valueKey, valueKey = _c === void 0 ? DEFAULT_VALUE_KEY : _c, _d = _a.getItemValue, getItemValue = _d === void 0 ? DEFAULT_GET_ITEM_VALUE : _d, _e = _a.findMatchIndex, findMatchIndex = _e === void 0 ? DEFAULT_FIND_MATCH_INDEX : _e;
    var _f = __read(useTempValue("", resetTime), 2), value = _f[0], setValue = _f[1];
    var values = useMemo(function () { return items.map(function (item) { return getItemValue(item, valueKey); }); }, [items, getItemValue, valueKey]);
    var handleKeyDown = useCallback(function (event) {
        if (onKeyDown) {
            onKeyDown(event);
        }
        var key = event.key, altKey = event.altKey, ctrlKey = event.ctrlKey, metaKey = event.metaKey;
        if (altKey ||
            ctrlKey ||
            metaKey ||
            key.length > 1 ||
            (!value.current && key === " ")) {
            // might need to change this later if other languages have non-meta keys
            // that are more than 1 letter
            return;
        }
        var nextValue = key;
        if (value.current !== key) {
            nextValue = "".concat(value.current).concat(key);
        }
        setValue(nextValue);
        var index = findMatchIndex(nextValue, values, searchIndex, true);
        // don't want to trigger change events if the search didn't match anything
        // since you normally don't really care about failed matches
        if (index === searchIndex || index === -1) {
            return;
        }
        var data = {
            index: index,
            item: items[index],
            items: items,
            query: nextValue,
            target: event.currentTarget,
        };
        onChange(data);
    }, [
        searchIndex,
        findMatchIndex,
        items,
        onChange,
        onKeyDown,
        setValue,
        value,
        values,
    ]);
    return handleKeyDown;
}
//# sourceMappingURL=useKeyboardSearch.js.map